import { useCallback, useMemo } from 'react';

import { isAIDPWorkflowEnabled } from '@/modules/aiDP/aidp.utils';
import { useDispositiveProvisionSuggestionsContext } from '@/modules/aiDP/context/dispositiveProvisionSuggestions.context';
import { RegenerateAISuggestionsMenuItem } from '@/modules/aiSuggestions/components/RegenerateAISuggestionsMenuItem';
import { useDispositiveProvisionsContext } from '@/modules/dispositiveProvisions/contexts/dispositiveProvisions.context';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';

export function RegenerateDPSuggestionsV2MenuItem() {
  const { householdId } = useHouseholdDetailsContext();
  const {
    isTestamentaryEntity,
    isClientProfile,
    entityType,
    clientProfileOrEntityOrTestamentaryEntityId,
  } = useDispositiveProvisionsContext();
  const { refetchSuggestions: refetchDPSuggestions } =
    useDispositiveProvisionSuggestionsContext();

  const handleCompleted = useCallback(() => {
    refetchDPSuggestions(clientProfileOrEntityOrTestamentaryEntityId);
  }, [clientProfileOrEntityOrTestamentaryEntityId, refetchDPSuggestions]);

  const showRegenAIDP = useMemo(() => {
    if (isClientProfile) return false;
    if (isTestamentaryEntity) return true;
    return isAIDPWorkflowEnabled(entityType);
  }, [entityType, isClientProfile, isTestamentaryEntity]);

  if (!showRegenAIDP || !householdId) return null;

  return (
    <RegenerateAISuggestionsMenuItem
      targetId={clientProfileOrEntityOrTestamentaryEntityId}
      householdId={householdId}
      onCompleted={handleCompleted}
      opts={{
        includeDPSuggestions: true,
        includeDetailsSuggestions: false,
      }}
      muiMenuItemProps={{ divider: true }}
    />
  );
}
